import { put, takeLatest } from "redux-saga/effects";
import {
  requestApprovePayment,
  requestApprovePaymentList,
} from "services/acclgl/client-Statement/approvePayment";
import {
  changePaymentStatusRequest,
  changePaymentStatusSuccess,
  changePaymentStatusFailure,
  fetchapprovePaymentListRequest,
  fetchapprovePaymentListSuccess,
  fetchapprovePaymentListFailure,
} from "redux/reducers/acclgl/clientStatement/approvePayment";

export function* watchapprovePayment() {
  yield takeLatest(fetchapprovePaymentListRequest, fetchapprovepaymentlist);
  yield takeLatest(changePaymentStatusRequest, createapprovepayment);
}

function* fetchapprovepaymentlist({ payload }) {
  try {
    const response = yield requestApprovePaymentList(payload);
    yield put(fetchapprovePaymentListSuccess(response));
  } catch (error) {
    yield put(
      fetchapprovePaymentListFailure("Failed to get list of Approve Payment")
    );
  }
}

function* createapprovepayment({ payload }) {
  try {
    const response = yield requestApprovePayment(payload);
    yield put(changePaymentStatusSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message;
    yield put(changePaymentStatusFailure(message));
  }
}
